/**
 * Идентификатор объекта из адреса страницы и в сигнатурах API: положительное целое
 * рабочего контура (BIGSERIAL в qhub) или строковый учебный train:<экземпляр>:<вид>:<ключ>
 * (E4.5). Что угодно другое -- undefined, страница показывает «не найдено».
 */
export type EntityId = number | string;

const TRAINING_ID =
	/^train:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}:[a-z0-9_]{1,32}:[A-Za-z0-9._-]{1,64}$/;

export function isTrainingId(raw: string): boolean {
	return TRAINING_ID.test(raw);
}

export function parseEntityId(raw: string | undefined | null): EntityId | undefined {
	if (raw === undefined || raw === null) return undefined;
	if (isTrainingId(raw)) return raw;
	if (!/^[1-9]\d*$/.test(raw)) return undefined;
	const id = Number(raw);
	return Number.isSafeInteger(id) ? id : undefined;
}

/** Сегмент пути API для идентификатора: учебный ID кодируется целиком */
export function entityPath(id: EntityId): string {
	return encodeURIComponent(String(id));
}

/** Валидный рабочий или учебный ID для включения чтения. */
export function isEntityId(value: unknown): value is EntityId {
	return typeof value === 'number'
		? Number.isSafeInteger(value) && value > 0
		: typeof value === 'string' && isTrainingId(value);
}
